






































import Vue from 'vue'
import LeftSidebarLayout from '@/components/LeftSidebarLayout'
import AddEditStream from '@/components/AddEditStream'
import TabDisplay from '@/components/TabDisplay'
import StreamList from './StreamList'
import './StreamsManager.scss'
import { Stream } from '@/types/streams'
import { KeyDict } from '@/types'
import { AbilityAction, AbilitySubject } from '@/abilitiesByRole'
import { Feature } from '@/featureFlags/featureFlags'

export default Vue.extend({
  name: 'StreamsManager',
  computed: {
    canDoOps (): boolean {
      return this.$can(AbilityAction.Do, AbilitySubject.Ops)
    },
    isSelfServe (): boolean {
      return this.$hasFeature(Feature.SELF_SERVE)
    },
    canReadStreams (): boolean {
      return this.$can(AbilityAction.Read, AbilitySubject.Stream)
    },
    canCreateStreams (): boolean {
      if (this.selectedTab === 'broadcast' && this.isSelfServe && !this.canDoOps) {
        return false
      } else {
        return this.$can(AbilityAction.Create, AbilitySubject.Stream)
      }
    },
    streams (): KeyDict<Stream> {
      return this.$store.direct.state.team.streams
    },
    activeTeam (): string {
      return this.$store.direct.state.team.activeTeam
    },
    teamCheck (): boolean | null {
      return this.$store.direct.state.user.teamCheck
    }
  },
  data: () => ({
    selectedStream: {},
    selectedStreamId: '',
    showAddEditModal: false,
    selectedTab: 'broadcast',
    tabs: [
      { label: 'Input', value: 'broadcast', icon: '' },
      { label: 'Output', value: 'output', icon: '' }
    ]
  }),
  methods: {
    showCreateStream () {
      this.selectedStream = {}
      this.selectedStreamId = ''
      this.showAddEditModal = true
    },
    showEditStream (streamId: string) {
      const selectedStream = this.streams[streamId]
      if (selectedStream === undefined) {
        console.warn('SteamsManager::showEditStream: stream did not exists')
        return
      }
      this.selectedStreamId = streamId
      this.selectedStream = selectedStream
      this.showAddEditModal = true
    },
    async createStream (stream: Stream) {
      try {
        const team = this.$store.direct.state.team.team
        await this.$store.direct.dispatch.team.createTeamStream({ stream, team })
        this.showAddEditModal = false
      } catch (error) {
        console.error('Error createStream: ', error)
        this.showAddEditModal = false
      }
    },
    async updateStream (stream: Stream) {
      try {
        this.$store.direct.dispatch.team.updateTeamStream({
          ...stream,
          team: this.activeTeam,
          team_id: this.activeTeam,
          id: this.selectedStreamId
        })
        this.showAddEditModal = false
      } catch (error) {
        console.error('Error updateTeamStream: ', error)
        this.showAddEditModal = false
      }
    },
    async deleteStream (stream: Stream) {
      try {
        await this.$store.direct.dispatch.team.deleteTeamStream(stream)
      } catch (error) {
        console.error('Error deleteTeamStream: ', error)
      }
    },
    tabChanged (tab: string) {
      this.selectedTab = tab
    },
    closeModal () {
      this.showAddEditModal = false
    }
  },
  components: {
    AddEditStream,
    LeftSidebarLayout,
    TabDisplay,
    StreamList
  }
})
